var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10C4.5 7.172 4.5 5.757 5.379 4.879C6.257 4 7.672 4 10.5 4H13.5C16.328 4 17.743 4 18.621 4.879C19.5 5.757 19.5 7.172 19.5 10V15C19.5 17.828 19.5 19.243 18.621 20.121C17.743 21 16.328 21 13.5 21H10.5C7.672 21 6.257 21 5.379 20.121C4.5 19.243 4.5 17.828 4.5 15V10Z",
    stroke: "#6B778C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.5 18C3.70435 18 2.94129 17.6839 2.37868 17.1213C1.81607 16.5587 1.5 15.7956 1.5 15V9C1.5 5.229 1.5 3.343 2.672 2.172C3.844 1.001 5.729 1 9.5 1H13.5C14.2956 1 15.0587 1.31607 15.6213 1.87868C16.1839 2.44129 16.5 3.20435 16.5 4",
    stroke: "#6B778C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.32a55de598055ea4ac5b28b75a1d6871.svg";
export { ForwardRef as ReactComponent };